export default "__VITE_ASSET__e1692513__"